import { DirectionalLight, PointLight } from 'three'
import { isDirectionalLight } from './type-guards'
import {
  LightConfig,
  isDirectionalLightConfig,
} from '../../../../trillion-common/src/objects/light-config.object'

export function createLightFromConfig(lightConfig: LightConfig) {
  const light = isDirectionalLightConfig(lightConfig)
    ? new DirectionalLight(lightConfig.color, lightConfig.intensity)
    : new PointLight(lightConfig.color, lightConfig.intensity)

  light.color.set(lightConfig.color)
  light.position.set(lightConfig.position.x, lightConfig.position.y, lightConfig.position.z)
  if (isDirectionalLight(light) && isDirectionalLightConfig(lightConfig)) {
    light.target.position.set(lightConfig.target.x, lightConfig.target.y, lightConfig.target.z)
  }
  light.name = lightConfig.name

  return light
}
